import React from "react";
import SocialItem from "./socialItem";
import {
	FaFacebookF,
	FaInstagram,
	FaSpotify,
	FaTwitter,
	FaTiktok,
} from "react-icons/fa";

/* Socials
============================================================================= */

const Socials = () => {
	// Config

	// Render
	return (
		<div className="flex flex-row items-center justify-start space-x-4">
			<a
				href="https://www.facebook.com/GoodThingsFestival/"
				target="_blank"
				rel="noopener noreferrer"
			>
				<SocialItem
					Icon={() => <FaFacebookF size={22.5} color="black" />}
				/>
			</a>
			<a
				href="https://www.instagram.com/goodthingsfestival/"
				target="_blank"
				rel="noopener noreferrer"
			>
				<SocialItem
					Icon={() => <FaInstagram size={22.5} color="black" />}
				/>
			</a>
			<a
				href="https://open.spotify.com/playlist/4JuWRMi91hQ6AeTSwRFmtD?si=e6178f7e55fd41da&pt=b82c9b2ed2a32b2c31b07a74ab6be6c4"
				target="_blank"
				rel="noopener noreferrer"
			>
				<SocialItem
					Icon={() => <FaSpotify size={22.5} color="black" />}
				/>
			</a>
			<a
				href="https://twitter.com/goodthingsfest"
				target="_blank"
				rel="noopener noreferrer"
			>
				<SocialItem
					Icon={() => <FaTwitter size={22.5} color="black" />}
				/>
			</a>
			<a
				href="https://www.tiktok.com/@goodthingsfestival?lang=en"
				target="_blank"
				rel="noopener noreferrer"
			>
				<SocialItem
					Icon={() => <FaTiktok size={22.5} color="black" />}
				/>
			</a>
		</div>
	);
};

/* Export
============================================================================= */

export default Socials;
